import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/index.css";
import { router } from "./App";
import reportWebVitals from "./reportWebVitals";

import {
	Route,
	Routes,
	createBrowserRouter,
	createRoutesFromElements,
	defer,
} from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { StrictMode } from "react";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<Routes>
					<Route path="/*" element={<App />} />
				</Routes>
			</AuthProvider>
		</BrowserRouter>
	</StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
